import { Injectable, inject } from '@angular/core';
import { dsApi, dsDtos } from '@vectronic/openApi-admin';
import { ReplaySubject, mergeMap, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HousingTypeService {
  private housingTypeApi = inject(dsApi.HousingTypes);
  constructor() {
    this.refresh().subscribe();
  }

  private _housingTypes$ = new ReplaySubject<dsDtos.HousingType[]>(1);

  housingTypes$() {
    return this._housingTypes$;
  }

  refresh() {
    return this.housingTypeApi
      .getHousingTypes()
      .pipe(tap((deviceTypes) => this._housingTypes$.next(deviceTypes)));
  }

  add(housingType: dsDtos.HousingTypeInput) {
    return this.housingTypeApi.addHousingType(housingType).pipe(mergeMap(() => this.refresh()));
  }

  edit(id: string, housingType: dsDtos.HousingTypeInput) {
    return this.housingTypeApi
      .editHousingType(id, housingType)
      .pipe(mergeMap(() => this.refresh()));
  }

  delete(id: string) {
    return this.housingTypeApi.deleteHousingType(id).pipe(mergeMap(() => this.refresh()));
  }
}
